const productTranslations = {
  en: {
    "automotive-relays": "Automotive Relays",
    "basic-switches": "Basic Switches",
    "detection-switches": "Detection Switches",
    "door-switchs_power-switches": "Door Switches/Power Switches",
    "tactile-switches": "Tactile Switches",
    "rocker-switches": "Rocker Switches",
    "pushbutton-switches_indicators": "Pushbutton Switches/Indicators",
    "toggle_pushbutton-switches": "Toggle/Pushbutton Switches",
    "dip-switches": "DIP Switches",
    "automotive-basic-switches": "Automotive Switches",
    connectors: "Connectors",
    "flow-sensors": "Flow Sensors",
    "photomicro-sensors_transmissive-types":
      "Photomicrosensors Transmissive Types",
    "photomicro-sensors_reflective-types": "Photomicrosensors Reflective Types",
  },
  jp: {
    "automotive-relays": "車載用リレー",
    "basic-switches": "マイクロスイッチ",
    "detection-switches": "検出スイッチ",
    "door-switchs_power-switches": "ドア/電源スイッチ",
    "tactile-switches": "タクタイルスイッチ",
    "rocker-switches": "ロッカースイッチ",
    "pushbutton-switches_indicators": "押ボタンスイッチ/表示灯",
    "toggle_pushbutton-switches": "トグル/プッシュスイッチ",
    "dip-switches": "ディップスイッチ",
    "automotive-basic-switches": "車載用スイッチ",
    connectors: "コネクタ",
    "flow-sensors": "流量センサ",
    "photomicro-sensors_transmissive-types": "フォト・マイクロセンサ 透過形",
    "photomicro-sensors_reflective-types": "フォト・マイクロセンサ 反射形",
  },
  cn: {
    "automotive-relays": "车载继电器",
    "basic-switches": "基本开关",
    "detection-switches": "检测开关",
    "door-switchs_power-switches": "门用开关/电源开关",
    "tactile-switches": "轻触开关",
    "rocker-switches": "船形开关",
    "pushbutton-switches_indicators": "按钮开关/显示灯",
    "toggle_pushbutton-switches": "拨动开关/按键开关",
    "dip-switches": "DIP开关",
    "automotive-basic-switches": "车载开关",
    connectors: "连接器",
    "flow-sensors": "流量传感器",
    "photomicro-sensors_transmissive-types": "微型光电传感器 透过型",
    "photomicro-sensors_reflective-types": "微型光电传感器 反射型",
  },
};

export default productTranslations;
